import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
export function UrgencySection() {
  return <section className="w-full bg-slate-50 py-12 md:py-16 px-4" data-id="element-364">
      <div className="max-w-4xl mx-auto" data-id="element-365">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-6" data-id="element-366">
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900" data-id="element-367">
            ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </h3>

          <Countdown data-id="element-368" />

          <p className="text-xl text-red-600 font-semibold" data-id="element-369">
            Después sube $15.000 ARS y no vuelve a bajar.
          </p>

          <div className="bg-white border border-slate-200 rounded-lg p-6 mt-8 shadow-sm" data-id="element-370">
            <p className="text-red-600 font-bold text-lg mb-4" data-id="element-371">
              🔴 Cupos al precio de lanzamiento
            </p>
            <div className="w-full bg-slate-200 rounded-full h-4 mb-3" data-id="element-372">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              ease: 'easeOut'
            }} className="bg-red-600 h-4 rounded-full" data-id="element-373" />
            </div>
            <p className="text-slate-600" data-id="element-374">68% de los cupos tomados</p>
            <p className="text-slate-900 font-semibold mt-2" data-id="element-375">
              Quedan pocos lugares a este precio.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}